import React from 'react';
import './VirtualTourLocked.scss';
import tourLockedImage from '../../images/tour-locked.svg';
import { publishTourOrder } from '../../services/tourServices';
import { useParams } from 'react-router-dom';

/**
 * VirtualTourLocked component
 * Displayed when a tour has enabled === false
 * @returns VirtualTourLocked component
 * @category Component
 */
const VirtualTourLocked = (): JSX.Element => {
  const { readCode } = useParams<{ readCode: string; mode: string }>();

  const orderVirtualTour = async () => {
        try {
            const order = await publishTourOrder(String(readCode), window.location.href);
            window.location.href = order.redirectUrl;
        } catch (error) {
        }
    };

  return (
    <div className='container tour-locked-layout'>
      <div className='container-tour-locked'>
        <h1 className='tour-locked-title'>Virtual Tour Locked</h1>
        <p className='tour-locked-text'>
          This tour is currently locked. Click below to unlock and enable full access.
          <br />
          Once unlocked, the tour will be immediately available.
        </p>
        <img className='tour-locked-img' src={tourLockedImage} alt='Tour locked' />
        <button className='unlock-button' onClick={() => orderVirtualTour()}>
          Unlock Now
        </button>
      </div>
    </div>
  );
};

export default VirtualTourLocked;
